<template>
  <v-dialog v-model="editRequestDialog">
    <v-card width="1200px" class="py-2" style="border-radius: 12px">
      <v-form ref="form" lazy-validation>
        <div class="row ma-4">
          <h1>
            {{ $t("actions.consult", { itm: $t("purchaseOrder.purchaseOrder") }) }}
          </h1>
        </div>

        <div class="row ma-4">
          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">
                {{ $t("purchaseOrder.title") }}
              </v-card-title>
            </div>
            <div class="row">
              <v-text-field v-model="editData.title" id="title" name="title" maxlength="30" hide-details
                persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('purchaseOrder.title') })"
                variant="outlined" class="rounded-xl readonly-field" readonly></v-text-field>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.reference") }}
              </v-card-title>
            </div>
            <div class="row">
              <v-text-field v-model="editData.reference" id="reference" name="reference" maxlength="30" hide-details
                persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('purchaseOrder.reference') })
                  " variant="outlined" class="rounded-xl readonly-field" readonly></v-text-field>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.supplier") }}</v-card-title>
            </div>
            <div class="row">
              <v-autocomplete id="Supplier" name="Supplier" class="pl-0 pr-6 readonly-field" variant="outlined"
                v-model="editData.IdSupplier" persistent-placeholder
                :placeholder="$t('placeholder.select', { itm: $t('purchaseOrder.supplier') })" :items="ListSupplier"
                item-title="brandName" item-value="id" hide-details readonly>
                <template v-slot:item="{ props, item, index }">
                  <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                    {{ item.brandName }}
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.devise") }}</v-card-title>
            </div>
            <div class="row">
              <v-autocomplete id="Devise" name="Devise" variant="outlined" v-model="editData.devise"
                persistent-placeholder :placeholder="$t('placeholder.select', { itm: $t('purchaseOrder.devise') })"
                :items="DeviseList" item-title="name" item-value="symbol" hide-details readonly class="readonly-field">
                <template v-slot:item="{ props, item, index }">
                  <v-list-item v-bind="props" variant="text" :id="index" :name="item.name">
                    {{ item.name }}
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.deliverydate") }} </v-card-title>
            </div>
            <div class="row">
              <dateField v-model="editData.expirationDate" :min-date="new Date('2000-01-01')" id="expirationDate"
                name="expirationDate" readonly class="readonly-field pe-none" />
            </div>
          </div>

          <v-table theme="white" class="table-responsive rounded-table mt-4" style="width: 100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="column-title border-right">{{ $t("purchaseOrder.title") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.quantity") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.amountHT") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.tax") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.montantHT") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.montantTotal") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(line, index) in editData.lines" :key="index" class="border-bottom">
                  <td class="column-title border-right col-2">
                    <span>
                      {{ line.title }}
                    </span>
                  </td>

                  <td class="column-small border-right col-2">
                    <span>
                      {{ line.quantity }}
                    </span>
                  </td>
                  <td class="border-right col-2">
                    <span>
                      {{ formatPrice(line.price) }}
                    </span>
                  </td>
                  <td class="column-small border-right col-2">
                    <span>
                      {{ line.tax }} %
                    </span>
                  </td>
                  <td class="border-right col-2">
                    <span>
                      {{ formatPrice(MTHTVA[index]) }}
                    </span>
                  </td>
                  <td class="border-right col-2">
                    <span>
                      {{ formatPrice(MTTotal[index]) }}
                    </span>
                    <div class="d-flex align-center">
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-table>
          <div class="col-8"></div>
          <div class="col-4 totals">
            <p class="ml-3 align-right">
              {{ $t("purchaseOrder.montantHT") }} :
              <strong>{{ formatPrice(totalAmountHT) }} </strong>
            </p>
            <div v-for="(amount, tax) in totaltaxs" :key="tax">
              <p class="align-right">
                <span>{{ $t("purchaseOrder.taxAmount") }} {{ tax }}% :
                  {{ formatPrice(amount) }}
                </span>
              </p>
            </div>
            <v-divider class="custom-divider"></v-divider>

            <p class="align-right">
              Total :
              <strong>{{ formatPrice(grandTotal) }}</strong>
            </p>
          </div>
        </div>
        <card-actions :yes="downloadPurchaseOrderPdf" v-model:no="editRequestDialog" width="300px"
          :yesTitle="$t('purchaseOrder.downloadPdf')" />
      </v-form>
    </v-card>
  </v-dialog>

</template>

<script>
import {
  formatPrice,
  generatePurchaseOrderPdf
} from "@/api/index";
import deviseJson from "@/data/DevisesList.json";
import cardActions from "@/genericComponent/cardActions.vue";
import dateField from "@/genericComponent/date-field.vue";

export default {
  components: { cardActions, dateField },
  props: [
    "idPurchaseOrder",
    "getPurchaseOrderListAfterDelete",
    "getPurchaseOrder",
    "SupplierList",
    "Id",
  ],
  mounted() {
    this.LatestPurchaseOrderState = this.createPurchaseOrderObject(this.getPurchaseOrder);
    this.editData.title = this.getPurchaseOrder.title;
    this.editData.reference = this.getPurchaseOrder.reference;
    this.editData.idPurchaseOrder = this.getPurchaseOrder.idPurchaseOrder;
    this.editData.lines = this.getPurchaseOrder.purchaseOrderLines;

    this.editData.lines.title = this.getPurchaseOrder.purchaseOrderLines.title;
    this.editData.price = this.getPurchaseOrder.price;
    this.editData.devise = this.currency;
    this.editData.type = this.getPurchaseOrder.type;
    this.editData.expirationDate = this.getPurchaseOrder.expirationDate;
    this.editData.tax = this.getPurchaseOrder.tax;
    this.editData.quantity = this.getPurchaseOrder.quantity;
    this.editData.IdSupplier = this.getPurchaseOrder.supplier.id;
    this.ListSupplier = [{ id: this.getPurchaseOrder.supplier.id, brandName: this.getPurchaseOrder.supplier.brandName }]
  },
  data() {
    return {
      LatestPurchaseOrderState: null,
      editRequestDialog: true,
      ListSupplier: [],
      editData: {
        supplier: null,
        reference: "",
        title: "",
        idPurchaseOrder: "",
        devise: "",
        type: null,
        expirationDate: new Date(),
        lines: [
          {
            idPurchaseOrderline: "",
            title: "",
            quantity: 1,
            price: null,
            IdSupplier: null,
            tax: null,
            errors: {},
          },
        ],
      },
      DeviseList: deviseJson,
    };
  },
  watch: {
    editRequestDialog() {
      this.$emit("close")
    },
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price)
    },
    createPurchaseOrderObject(getPurchaseOrder) {
      const lines = getPurchaseOrder.purchaseOrderLines ?? getPurchaseOrder.lines;
      return {
        supplier: getPurchaseOrder.supplier?.id ?? getPurchaseOrder.IdSupplier,
        reference: getPurchaseOrder.reference,
        title: getPurchaseOrder.title,
        devise: this.currency,
        expirationDate: getPurchaseOrder.expirationDate.split("T")[0],
        lines: lines.map((line) => ({
          title: line.title ? line.title : line.title,
          quantity: line.quantity ? parseFloat(line.quantity) : parseFloat(line.quantity),
          price: line.price ? parseFloat(line.price) : parseFloat(line.price),
          tax: line.tax ? parseFloat(line.tax) : parseFloat(line.tax),
        })),
      };
    },
    FormatTotal(total) {
      let formattedTotal = total.toFixed(3).toString();
      if (formattedTotal.includes(".")) {
        formattedTotal = formattedTotal.replace(/\.?0+$/, "");
      }
      return formattedTotal;
    },
    CalculateTotal(quantity, price, tax) {
      if (
        quantity !== "" &&
        quantity != null &&
        price !== "" &&
        price !== null &&
        tax !== null
      ) {
        const amountTTC =
          parseFloat(quantity) * parseFloat(price) * (parseFloat(tax) / 100);
        let total = parseFloat(quantity) * parseFloat(price) + amountTTC;
        let parts = total.toString().split(".");
        if (parts[1] && parts[1].length > 3) {
          return total.toFixed(3);
        } else {
          return total.toFixed(3);
        }
      } else {
        return null;
      }
    },
    async downloadPurchaseOrderPdf() {
      try {
        if (!this.getPurchaseOrder.idPurchaseOrder) {
          this.$toast.error(this.$t("purchaseOrder.errorNoPurchaseOrderId"));
          return;
        }

        const response = await generatePurchaseOrderPdf(this.getPurchaseOrder.idPurchaseOrder);

        // Création de l'URL Blob pour le téléchargement
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nom du fichier
        link.setAttribute("download", `PurchaseOrder_${this.getPurchaseOrder.reference}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading PurchaseOrder PDF:", error);
        this.$toast.error(this.$t("purchaseOrder.errorDownloadPdf"));
      }
    },
  },

  computed: {
    purchaseOrderState() {
      const isSame =
        JSON.stringify(this.LatestPurchaseOrderState) ===
        JSON.stringify(this.createPurchaseOrderObject(this.editData));
      return isSame;
    },

    totaltaxs() {
      const taxs = {};
      this.editData.lines.forEach((line) => {
        if (
          line.quantity !== "" &&
          line.quantity !== null &&
          line.price !== "" &&
          line.price != null &&
          line.tax >= 0 &&
          line.tax !== null
        ) {
          const lineTotal = parseFloat(line.quantity) * parseFloat(line.price);
          const taxAmount = lineTotal * (parseFloat(line.tax) / 100);
          if (taxs[line.tax]) {
            taxs[line.tax] += taxAmount;
          } else {
            taxs[line.tax] = taxAmount;
          }
        }
      });

      return taxs;
    },
    grandTotal() {
      let total = 0;
      if (Array.isArray(this.MTTotal)) {
        this.MTTotal.forEach((amount) => {
          if (amount !== null) {
            total += parseFloat(amount);
          }
        });
      }
      return total;
    },
    totalAmountHT() {
      return this.editData.lines.reduce((total, line) => {
        if (
          line.quantity !== "" &&
          line.quantity !== null &&
          line.price !== "" &&
          line.price != null
        ) {
          return total + parseFloat(line.quantity) * parseFloat(line.price);
        }
        return total;
      }, 0);
    },
    MTHTVA() {
      return this.editData.lines.map((line) => {
        if (
          line.quantity !== "" &&
          line.quantity !== null &&
          line.price !== "" &&
          line.price != null
        ) {
          let total = parseFloat(line.quantity) * parseFloat(line.price);
          return this.FormatTotal(total);
        } else {
          return null;
        }
      });
    },
    MTTotal() {
      return this.editData.lines.map((line) => {
        return this.CalculateTotal(line.quantity, line.price, line.tax);
      });
    },
    currency() {
      return window.VUE_APP_CURRENCY;
    },
  },
};
</script>
<style scoped>
h1 {
  font-family: inter;
  font-size: 18px;
  line-height: 29px;
  font-weight: 600;
  color: #0d0849;
  text-align: center;
}

.v-card-text {
  font-family: inter;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #768da9;
}

.rounded-table {
  border-radius: 10px;
}

.custom-divider {
  border-top: 1px solid;
  border-color: currentColor;
}

.border-right {
  border: 1px solid #ddd;
  text-align: center;
  border-style: dotted;
  padding: 2px 4px;
}

.totals {
  margin-top: 20px;
  /* font-weight: bold; */
}

.align-right {
  padding-right: 85px;
  text-align: right;
  position: relative;
}

.totals p {
  margin: 5px 0;
}

.align-devise {
  float: right;
  margin-left: -16px;
}

.v-card-title {
  font-family: inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #5b6d8e;
}

.textConsumptionThreshold {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #080c3e;
}

.customWarningHint {
  color: #f25c5c;
  padding: 12px 0px 12px 12px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 0px;
  display: block;
  text-align: left;
  text-wrap: nowrap;
}

.column-title {
  width: 35%;
  /* Ajustez selon vos besoins */
}

.column-small {
  width: 8%;
  /* Ajustez selon vos besoins */
}
</style>